import jwtDecode from "jwt-decode";

export const isTokenExpired = (token, bufferSeconds = 5) => {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);

    if (!decoded?.exp) {
      return true;
    }

    return decoded.exp * 1000 <= Date.now() + bufferSeconds * 1000;
  } catch {
    return true;
  }
};
